<app-input-search
  [isFinishLoadingSubject]="isFinishLoading"
  [placeholder]="'Cari nama program'"
  [value]="service.keyword()"
  (actionFilter)="handleSearch($event)"
></app-input-search>

<div class="ms-auto position-relative" data-kt-customer-table-toolbar="base">
  <app-filter-table
    [isFinishLoadingSubject]="isFinishLoading"
    [isActiveFilter]="isFilterActive()"
    [isOpenFilter]="isFilterOpen()"
    (actionClick)="handleOpenFilter()"
    (actionReset)="handleResetFilter()"
    resetLabel="Reset Filter"
  >
    <div
      class="menu menu-sub menu-sub-dropdown w-300px w-md-350px show filter-body"
      id="kt-toolbar-filter"
    >
      <div class="px-7 py-5">
        <div class="fs-4 text-dark fw-bold">Filter</div>
      </div>
      <div class="separator border-gray-200"></div>
      <div class="px-7 py-5">
        <form [formGroup]="filterForm" (ngSubmit)="handleApplyFilter()">
          <div class="mb-10">
            <app-input-select-radio
              label="Progres Target"
              formControlName="progressTypeFilterControl"
              [options]="filterOptions"
              [useColumn]="true"
              rowClass="flex-column"
            ></app-input-select-radio>
          </div>
          <div class="d-flex justify-content-end">
            <button
              mat-flat-button
              (click)="handleResetFilter()"
              class="btn btn-outline text-primary me-4"
              type="reset"
            >
              Reset
            </button>
            <button
              mat-button
              color="primary"
              class="btn btn-primary btn-sm text-white"
              type="submit"
              [disabled]="filterForm.invalid"
            >
              Terapkan
            </button>
          </div>
        </form>
      </div>
    </div>
  </app-filter-table>
</div>
